//compareByOBBMaxSideArea: Used to sort children by size (largest first)
export type HasMaxSideArea = { obbMaxSideArea: number };
export const compareByOBBMaxSideArea = (
  a: HasMaxSideArea,
  b: HasMaxSideArea,
): number => b.obbMaxSideArea - a.obbMaxSideArea;
